export default {
  business: 'Business',
  'get-inspired': 'Låt dig inspireras',
  'how-to': 'Hur man gör',
  news: 'Nyheter',
  printstories: 'Printstories',
  highlights: 'Höjdpunkter',
  'business-growth': 'Företagstillväxt',
}
